import { useAnnotationStore } from "@frontend/stores/annotation-store"
import { useHistoryStore } from "@frontend/stores/history-store"
import { useEffect } from "react"

/**
 * Captures one history checkpoint per mutation burst (coalesced per microtask).
 */
export function useAnnotationHistoryBridge(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return

    let disposed = false
    let lastCapturedSeq = useAnnotationStore.getState().mutationSeq
    let flushScheduled = false

    const flush = () => {
      flushScheduled = false
      if (disposed) return

      const annotationState = useAnnotationStore.getState()
      if (annotationState.mutationSeq <= lastCapturedSeq) return

      const historyState = useHistoryStore.getState()
      if (!historyState.session) return

      lastCapturedSeq = annotationState.mutationSeq
      historyState.captureCheckpoint(annotationState.getSnapshot(), "mutation")
    }

    const unsubscribe = useAnnotationStore.subscribe((state) => {
      if (state.mutationSeq <= lastCapturedSeq || flushScheduled) return
      flushScheduled = true
      queueMicrotask(flush)
    })

    return () => {
      disposed = true
      unsubscribe()
    }
  }, [enabled])
}
